import { WebhooksGetRequestParams } from "@lib/core";

export interface WebhookDefaultParams extends WebhooksGetRequestParams { }
export class WebhookDefaultParams {
  constructor() {
    this.select = "*,\
      provider:providers(*)";
    this.order = "id.asc";
  }
}